<script>
	import { Card, Image } from "sveltestrap";
	export let description;
	export let createdAt;
	export let imageUrl;
	import { convert } from "../../../../../services/helpers";
	export let handleImgClick;
</script>

<Card body class="mb-2">
	<h6><b>{description}</b></h6>
	<p>{convert(createdAt)}</p>
	<div class="my-2">
		{#each imageUrl as src, index}
			<div
				class="container-checkbox"
				on:keyup={() => {}}
				on:click={() => handleImgClick(index, imageUrl)}
				style="height:auto; border: 0px !important; padding: 5px !important;
outline: 0 !important;"
			>
				<Image
					{src}
					style="width:100%; height:230px; object-fit: scale;"
					alt="vehicle image"
				/>
			</div>
		{/each}
	</div>
</Card>

<style>
	.container-checkbox {
		position: relative;
		float: left;
		width: 25%;
		padding: 5px;
	}
</style>
